module.exports = __webpack_public_path__ + "static/artboard2-71e35ebd13fcf32884e3888459462f6f.png";